import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useState, useEffect, Fragment } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useMediaQuery, useTheme } from '@mui/material';
import { useFormContext, } from "react-hook-form-mui";
import { CustomSelectElement } from "../../layouts/Theme";
export default function Variation(props) {
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { setValue, getValues } = useFormContext();
    // const [value, setValue] = useState<any>()
    const [useButtons, setUseButtons] = useState(false);
    const [showAllOptions, setShowAllOptions] = useState(false);
    const [internalValue, setInternalValue] = useState();
    const [cutoff, setCutoff] = useState(30);
    const [cutoffItems, setCutoffItems] = useState(0);
    const [options, setOptions] = useState([]);
    const handleChange = (value) => {
        setValue(`variation_${props.variance.id}`, value);
        if (props.setter) {
            props.setter(value);
        }
        setInternalValue(value);
    };
    const handleClick = (e) => {
        let value = parseInt(e.target.closest('button').getAttribute('rel'));
        setValue(`variation_${props.variance.id}`, value);
        if (props.setter) {
            props.setter(value);
        }
        setInternalValue(value);
    };
    useEffect(() => {
        let _options = [], _default = undefined;
        props.variance.variations.map((row, index) => {
            let _option = {
                id: row.id,
                label: row.variationName,
            };
            _options.push(_option);
            if (row.default) {
                _default = row.id;
            }
        });
        setOptions(_options);
        if (_default) {
            setValue(`variation_${props.variance.id}`, _default);
            if (props.setter) {
                props.setter(_default);
            }
            setInternalValue(_default);
        }
    }, []);
    useEffect(() => {
        if ((options === null || options === void 0 ? void 0 : options.length) > 0 && !getValues(`variation_${props.variance.id}`)) {
            setValue(`variation_${props.variance.id}`, options[0].id);
            if (props.setter) {
                props.setter(options[0].id);
            }
            setInternalValue(options[0].id);
        }
        if (options.length > 0) {
            let testString = '', items = cutoffItems;
            options.map((option, i) => {
                // the 2 spaces around the label represent the button padding, it's not very precise but good enough to determine a reasonable limit
                testString = testString.concat(` ${option.label} `);
                if (testString.length < cutoff) {
                    items = i + 1;
                }
            });
            // at least one button fits, and we don't have more than 10 buttons
            if (items > 0 && items < 10) {
                setUseButtons(true);
                setCutoffItems(items);
            }
            // else just use the select
        }
    }, [options]);
    const showAllOptionButtons = () => {
        setShowAllOptions(true);
    };
    return (_jsx(_Fragment, { children: options.length > 1 && (_jsxs(Box, { sx: { minWidth: 120, my: 2, maxWidth: isLarge ? '600px' : '100%' }, children: [useButtons && (_jsx(_Fragment, { children: options.map((option, i) => {
                        if (i < cutoffItems || showAllOptions) {
                            return (_jsx(Fragment, { children: _jsx(Button, { rel: option.id.toString(), onClick: handleClick, sx: {
                                        minWidth: 0,
                                        marginRight: '4px',
                                        marginBottom: '4px',
                                        fontSize: '1rem',
                                        color: theme.palette.text.primary,
                                        borderColor: theme.palette.text.primary,
                                        "&:hover": {
                                            background: theme.palette.primary.main,
                                            color: theme.palette.primary.contrastText,
                                            borderColor: theme.palette.text.primary,
                                        }
                                    }, variant: internalValue === option.id ? "contained" : "outlined", size: "small", children: option.label }) }, option.id));
                        }
                        if (i === cutoffItems && options.length > cutoffItems) {
                            return (_jsx(Fragment, { children: _jsxs(Button, { onClick: showAllOptionButtons, sx: {
                                        marginRight: '4px',
                                        marginBottom: '4px',
                                        fontSize: '1rem',
                                        minWidth: 0,
                                        color: theme.palette.text.primary,
                                        borderColor: theme.palette.text.primary,
                                        "&:hover": {
                                            background: theme.palette.primary.main,
                                            color: theme.palette.primary.contrastText,
                                            borderColor: theme.palette.text.primary,
                                        }
                                    }, variant: "outlined", size: "small", children: ["+", options.length - cutoffItems] }) }, option.id));
                        }
                        return (_jsx(Fragment, {}, option.id));
                    }) })), !useButtons && (_jsx(CustomSelectElement, { label: props.variance.name, 
                    // defaultValue={value}
                    // value={value}
                    name: `variation_${props.variance.id}`, onChange: handleChange, options: options }))] })) }));
}
